import { render } from "./ActiveAds.vue?vue&type=template&id=52c3ef40"
import script from "./ActiveAds.vue?vue&type=script&lang=js"
export * from "./ActiveAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__